import Breadcrumb from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import InvoiceWhatsAppCell from "components/InvoiceWhatsAppCell"
import dayjs from "dayjs"
import {
    getAllSubscriptionV2,
    cancelSubscriptionV2,
} from "helpers/backendHelpers/manageSubscription"
import React, { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import {
    Col,
    Row,
    UncontrolledTooltip,
    Card,
    CardBody,
    Container,
    Badge,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input,
    Label,
} from "reactstrap"
import SubscriptionModal from "./ViewModal"
import EditModal from "./EditModal"
import InfoModal from "./InfoModal"
import DynamicTable from "components/Common/DynamicTable"
import { DateRangePicker } from "rsuite"
import { getPredefinedDateRanges } from "helpers/dateRanges"

const Subscription = props => {
    const [loading, setLoading] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [modal1, setModal1] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [infoModal, setInfoModal] = useState(false)
    const [selectedRowForInfo, setSelectedRowForInfo] = useState(null)
    const [isInvoice, setIsInvoice] = useState(false)
    const [cancelModal, setCancelModal] = useState(false)
    const [cancelRow, setCancelRow] = useState(null)
    const [cancelReason, setCancelReason] = useState("Subscription cancellation refund")
    const [cancelLoading, setCancelLoading] = useState(false)
    const [deductUsedDaysForCancel, setDeductUsedDaysForCancel] = useState(false)

    const toggleInfoModal = () => {
        setInfoModal(!infoModal)
    }
    const [pageIndex, setPageIndex] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalRecords, setTotalRecords] = useState(0)
    const [searchInput, setSearchInput] = useState("")
    const [appliedSearch, setAppliedSearch] = useState("")
    const [selectedFilter, setSelectedFilter] = useState("all");
    const [subscriptionData, setSubscriptionData] = useState([])
    const [date, setDate] = useState({
        startDate: null,
        endDate: null,
    })

    const [form, setForm] = useState({
        planId: "",
        userId: "",
        planAmount: 0,
        discountAmount: 0
    })

    const getUserKey = subscription => {
        return subscription?.userId?._id || subscription?.userId?.userName || subscription?._id
    }

    const applySearch = () => {
        setPageIndex(0)
        setAppliedSearch(searchInput.trim())
    }

    //* toggle view modal
    const toggleViewModal = () => {
        if (modal1 == false) {
            setModal1(true)
        } else {
            setIsInvoice(false)
            setModal1(false)
        }
    }

    const toggleEditModal = () => {
        setEditModal(!editModal)
    }

    const isPaidBaseSubscription = row => (
        row?.paymentId?.paymentStatus === "paid" &&
        row?.paymentId?.paymentFor === "subscription" &&
        row?.planId?.planType !== "trial" &&
        row?.planId?.name?.toLowerCase() !== "free"
    )

    const roundCurrency = value => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100

    const getPlanDurationDays = plan => {
        const cycleCount = Number(plan?.noOfBillingCycle || 0)
        const cycle = String(plan?.billingCycle || "").toLowerCase()
        if (!cycleCount) return 0
        if (cycle.includes("day")) return cycleCount
        if (cycle.includes("month")) return cycleCount * 30
        if (cycle.includes("year")) return cycleCount * 365
        return 0
    }

    const getCancellationPreview = (row, deductUsedDays = false) => {
        const invoiceDate = row?.paymentId?.invoiceDate || row?.paymentId?.createdAt || row?.createdAt
        const refundEndDate = dayjs(invoiceDate).add(29, "day")
        const today = dayjs()
        const planDurationDays = getPlanDurationDays(row?.planId)
        const originalTaxableAmount = roundCurrency(row?.paymentId?.planAmount || 0)
        const originalTaxAmount = roundCurrency(row?.paymentId?.taxAmount || 0)
        const originalTotalAmount = roundCurrency(row?.paymentId?.finalAmount || 0)
        const taxRate = originalTaxableAmount > 0 ? Number(row?.paymentId?.taxAmount || 0) / originalTaxableAmount : 0
        const withinWindow = today.isBefore(refundEndDate.endOf("day")) || today.isSame(refundEndDate, "day")
        const usedDaysFromInvoice = Math.max(0, today.startOf("day").diff(dayjs(invoiceDate).startOf("day"), "day"))
        const shouldDeductUsedDays = !withinWindow || deductUsedDays === true
        const usedDays = shouldDeductUsedDays && planDurationDays ? Math.min(usedDaysFromInvoice, planDurationDays) : 0
        const dailyRate = shouldDeductUsedDays && planDurationDays ? originalTaxableAmount / planDurationDays : 0
        const usedAmount = roundCurrency(dailyRate * usedDays)
        const refundTaxableAmount = shouldDeductUsedDays ? roundCurrency(Math.max(0, originalTaxableAmount - usedAmount)) : originalTaxableAmount
        const refundTaxAmount = shouldDeductUsedDays ? roundCurrency(refundTaxableAmount * taxRate) : originalTaxAmount
        const refundAmount = roundCurrency(refundTaxableAmount + refundTaxAmount)
        const sameGstMonth = dayjs(invoiceDate).isSame(today, "month") && dayjs(invoiceDate).isSame(today, "year")
        return {
            invoiceDate,
            refundEndDate,
            withinWindow,
            sameGstMonth,
            deductUsedDays: shouldDeductUsedDays,
            requiresCreditNote: shouldDeductUsedDays || !sameGstMonth,
            proratedRefund: shouldDeductUsedDays,
            planDurationDays,
            usedDays,
            dailyRate: roundCurrency(dailyRate),
            usedAmount,
            refundTaxableAmount,
            refundTaxAmount,
            refundAmount,
            originalTaxableAmount,
            originalTaxAmount,
            originalTotalAmount,
        }
    }

    const openCancelModal = row => {
        setCancelRow(row)
        setCancelReason("Subscription cancellation refund")
        setDeductUsedDaysForCancel(false)
        setCancelModal(true)
    }

    const closeCancelModal = () => {
        setCancelModal(false)
        setCancelRow(null)
        setDeductUsedDaysForCancel(false)
        setCancelReason("Subscription cancellation refund")
    }

    const handleCancelSubscription = async () => {
        if (!cancelRow?._id) return
        try {
            setCancelLoading(true)
            await cancelSubscriptionV2(cancelRow._id, {
                reason: cancelReason,
                deductUsedDays: deductUsedDaysForCancel,
            })
            closeCancelModal()
            fetchAllSubscriptionV2(appliedSearch, selectedFilter, date.startDate, date.endDate)
        } catch (error) {
            window.alert(error?.response?.data?.message || error?.message || "Unable to cancel subscription")
        } finally {
            setCancelLoading(false)
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: "User Name",
                accessor: "userDetails",
                filterable: true,
                Cell: cellProps => {
                    return cellProps.row.original?.userId?.userName || "-"
                },
            },
            {
                Header: "Invoice No.",
                accessor: "invoiceNo",
                filterable: true,
                Cell: cellProps => {
                    return cellProps.row.original?.paymentId?.invoiceNo || "-"
                },
            },
            {
                Header: "Invoice Date",
                accessor: "createdAt",
                filterable: true,
                Cell: cellProps => {
                    const data = cellProps.row.original;
                    const dateToShow = data?.paymentId?.invoiceDate || data?.createdAt;
                    return dayjs(dateToShow).format("DD/MM/YYYY")
                },
            },
            {
                Header: "Plan Name",
                accessor: "name",
                filterable: true,
                Cell: cellProps => {
                    return cellProps.row.original?.planId?.name || "-"
                },
            },
            {
                Header: "Plan Amount",
                accessor: "planAmount",
                filterable: true,
                Cell: cellProps => {
                    return cellProps.row.original?.paymentId?.planAmount || "-"
                },
            },
            {
                Header: "Payment Mode",
                accessor: "paymentMode",
                filterable: true,
                Cell: cellProps => {
                    return cellProps.row.original?.paymentId?.paymentMode || "-"
                },
            },
            {
                Header: "Expiration Date",
                accessor: "expiryDate",
                filterable: true,
                Cell: cellProps => {
                    const data = cellProps.row.original
                    return <span>{dayjs(data?.expiryDate).format("DD/MM/YYYY")}</span>
                },
            },
            {
                Header: "Status",
                accessor: "isActive",
                disableFilters: true,
                Cell: cellProps => {
                    const cellData = cellProps.row.original
                    if (cellData?.paymentId?.isInvoiceCancelled) return <Badge color="danger">Cancelled</Badge>
                    if (cellData?.isActive && !cellData?.isExpired) return <Badge color="success">Active</Badge>
                    if (cellData?.isExpired) return <Badge color="secondary">Expired</Badge>
                    return <Badge color="warning">Inactive</Badge>
                },
            },
            {
                Header: "Expired",
                accessor: "isExpired",
                disableFilters: true,
                Cell: cellProps => {
                    const cellData = cellProps.row.original
                    return cellData.isExpired ? <Badge color="secondary">Yes</Badge> : <Badge color="success">No</Badge>
                },
            },
            {
                Header: "Invoice Send",
                accessor: "paymentId.invoiceWhatsAppStatus",
                disableFilters: true,
                Cell: cellProps => {
                    const row = cellProps.row.original
                    if (!isPaidBaseSubscription(row) || !row?.paymentId?.invoiceUrl) return "-"
                    return (
                        <InvoiceWhatsAppCell
                            payment={row.paymentId}
                            onSent={() => fetchAllSubscriptionV2(appliedSearch, selectedFilter, date.startDate, date.endDate)}
                        />
                    )
                },
            },

            {
                Header: "Action",
                accessor: "action",
                disableFilters: true,
                Cell: cellProps => {
                    const rowData = cellProps?.row?.original
                    const showEdit = rowData?.isActive === true &&
                                     rowData?.isExpired === false &&
                                     rowData?.paymentId?.paymentStatus === "paid";
                    const showCancel = showEdit && isPaidBaseSubscription(rowData) && !rowData?.paymentId?.isInvoiceCancelled;
                    const creditNoteUrl = rowData?.creditNoteId?.pdfUrl;
                    return (
                        <div className="d-flex gap-3 align-items-center">
                            <i
                                className="bx bxs-file-pdf font-size-24 cursor-pointer text-danger"
                                id={`invoiceTooltip-${rowData?._id}`}
                                onClick={() => {
                                    setForm(rowData)
                                    setIsInvoice(true)
                                    toggleViewModal()
                                }}
                            />
                            <UncontrolledTooltip placement="top" target={`invoiceTooltip-${rowData?._id}`}>
                                Invoice
                            </UncontrolledTooltip>
                            <Link
                                to="#"
                                className="text-primary"
                                onClick={() => {
                                    setForm(rowData)
                                    toggleViewModal()
                                }}
                            >
                                <i className="mdi mdi-eye font-size-18" id={`viewTooltip-${rowData?._id}`} />
                                <UncontrolledTooltip placement="top" target={`viewTooltip-${rowData?._id}`}>
                                    View
                                </UncontrolledTooltip>
                            </Link>
                            {showEdit && (
                                <>
                                    <i
                                        className="mdi mdi-pencil font-size-18 text-success cursor-pointer"
                                        id={`editTooltip-${rowData?._id}`}
                                        onClick={() => {
                                            setForm(rowData)
                                            toggleEditModal()
                                        }}
                                    />
                                    <UncontrolledTooltip placement="top" target={`editTooltip-${rowData?._id}`}>
                                        Edit Invoice
                                    </UncontrolledTooltip>
                                </>
                            )}
                            {rowData?.isEdited && rowData?.isExpired !== true && (
                                <>
                                    <i
                                        className="mdi mdi-information font-size-18 text-info cursor-pointer"
                                        id={`infoTooltip-${rowData?._id}`}
                                        onClick={() => {
                                            setSelectedRowForInfo(rowData)
                                            toggleInfoModal()
                                        }}
                                    />
                                    <UncontrolledTooltip placement="top" target={`infoTooltip-${rowData?._id}`}>
                                        Edit Info
                                    </UncontrolledTooltip>
                                </>
                            )}
                            {showCancel && (
                                <>
                                    <i
                                        className="mdi mdi-cancel font-size-18 text-danger cursor-pointer"
                                        id={`cancelTooltip-${rowData?._id}`}
                                        onClick={() => openCancelModal(rowData)}
                                    />
                                    <UncontrolledTooltip placement="top" target={`cancelTooltip-${rowData?._id}`}>
                                        Cancel Subscription
                                    </UncontrolledTooltip>
                                </>
                            )}
                            {creditNoteUrl && (
                                <>
                                    <a
                                        href={creditNoteUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-danger"
                                        id={`creditNoteTooltip-${rowData?._id}`}
                                    >
                                        <i className="mdi mdi-file-document font-size-18" />
                                    </a>
                                    <UncontrolledTooltip placement="top" target={`creditNoteTooltip-${rowData?._id}`}>
                                        Credit Note
                                    </UncontrolledTooltip>
                                </>
                            )}
                        </div>
                    )
                },
            },
        ],
        []
    )

    const fetchAllSubscriptionV2 = async (search = "", filterValue = "all", startDate = null, endDate = null) => {
        try {
            setLoading(true)
            let subscriptionList = []
            let recordCount = 0

            if (filterValue === "expired") {
                const allSubscriptionsResponse = await getAllSubscriptionV2({
                    search,
                    filterValue: "all",
                    startDate,
                    endDate,
                })

                let allSubscriptions = allSubscriptionsResponse?.payload?.data || []
                allSubscriptions = allSubscriptions.filter(subscription =>
                    subscription?.planId?.planType !== 'trial' &&
                    subscription?.planId?.name?.toLowerCase() !== 'free'
                )

                const usersWithActiveSubscription = new Set(
                    allSubscriptions
                        .filter(subscription => subscription?.isActive && !subscription?.isExpired)
                        .map(getUserKey)
                        .filter(Boolean)
                )

                const filteredExpiredSubscriptions = allSubscriptions.filter(subscription => {
                    if (!subscription?.isExpired) {
                        return false
                    }

                    const userKey = getUserKey(subscription)
                    return !userKey || !usersWithActiveSubscription.has(userKey)
                })

                recordCount = filteredExpiredSubscriptions.length
                const startIndex = pageIndex * pageSize
                subscriptionList = filteredExpiredSubscriptions.slice(startIndex, startIndex + pageSize)
            } else {
                const params = { page: pageIndex + 1, limit: pageSize, search, filterValue, startDate, endDate }
                const response = await getAllSubscriptionV2(params)
                subscriptionList = response?.payload?.data || []
                recordCount = response?.payload?.count || 0
            }

            setTotalRecords(recordCount)
            setSubscriptionData(subscriptionList)
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        document.title = "User | React Admin & User Template"
        fetchAllSubscriptionV2(appliedSearch, selectedFilter, date.startDate, date.endDate)
    }, [pageIndex, pageSize, selectedFilter, date, appliedSearch])

    return (
        <React.Fragment>
            <SubscriptionModal
                isOpen={modal1}
                isInvoice={isInvoice}
                toggle={toggleViewModal}
                data={form}
            />

            <EditModal
                isOpen={editModal}
                toggle={toggleEditModal}
                data={form}
                onUpdateSuccess={() => fetchAllSubscriptionV2(appliedSearch, selectedFilter, date.startDate, date.endDate)}
            />

            <InfoModal
                isOpen={infoModal}
                toggle={toggleInfoModal}
                data={selectedRowForInfo}
            />

            <Modal isOpen={cancelModal} toggle={closeCancelModal}>
                <ModalHeader toggle={closeCancelModal}>Cancel Subscription</ModalHeader>
                <ModalBody>
                    {cancelRow && (() => {
                        const preview = getCancellationPreview(cancelRow, deductUsedDaysForCancel)
                        return (
                            <>
                                <p className="mb-2"><strong>User:</strong> {cancelRow?.userId?.userName || "-"}</p>
                                <p className="mb-2"><strong>Invoice No:</strong> {cancelRow?.paymentId?.invoiceNo || "-"}</p>
                                <p className="mb-2"><strong>Invoice Date:</strong> {dayjs(preview.invoiceDate).format("DD/MM/YYYY")}</p>
                                <p className="mb-2"><strong>Plan Base Amount:</strong> Rs. {preview.originalTaxableAmount.toFixed(2)}</p>
                                <p className="mb-2"><strong>GST:</strong> Rs. {preview.originalTaxAmount.toFixed(2)}</p>
                                <p className="mb-2"><strong>Total Paid:</strong> Rs. {preview.originalTotalAmount.toFixed(2)}</p>
                                {preview.withinWindow && (
                                    <div className="mb-3">
                                        <Label>Used Days Deduction</Label>
                                        <Input
                                            type="select"
                                            value={deductUsedDaysForCancel ? "deduct" : "full"}
                                            onChange={e => setDeductUsedDaysForCancel(e.target.value === "deduct")}
                                        >
                                            <option value="full">No deduction - full refund</option>
                                            <option value="deduct">Deduct used days</option>
                                        </Input>
                                    </div>
                                )}
                                {!preview.withinWindow && (
                                    <div className="alert alert-warning py-2">
                                        Used days deduction is mandatory because cancellation is outside the 30-day refund window.
                                    </div>
                                )}
                                {preview.proratedRefund && (
                                    <div className="alert alert-info py-2">
                                        <div><strong>Unused Days Refund:</strong> {preview.usedDays} of {preview.planDurationDays || "-"} days used</div>
                                        <div>Used Base Amount: Rs. {preview.usedAmount.toFixed(2)}</div>
                                        <div>Refund Base Amount: Rs. {preview.refundTaxableAmount.toFixed(2)}</div>
                                        <div>Refund GST: Rs. {preview.refundTaxAmount.toFixed(2)}</div>
                                    </div>
                                )}
                                <p className="mb-2"><strong>Refund Amount:</strong> Rs. {preview.refundAmount.toFixed(2)}</p>
                                <p className="mb-2"><strong>Refund Window:</strong> {dayjs(preview.invoiceDate).format("DD/MM/YYYY")} to {preview.refundEndDate.format("DD/MM/YYYY")}</p>
                                <p className="mb-2">
                                    <strong>Action:</strong>{" "}
                                    {preview.requiresCreditNote ? "Generate credit note, cancel invoice and deactivate plan" : "Cancel invoice and deactivate plan"}
                                </p>
                                <div className="alert alert-warning">Refund money is record-only here. Process actual refund manually.</div>
                                <Label>Reason</Label>
                                <Input
                                    type="textarea"
                                    value={cancelReason}
                                    onChange={e => setCancelReason(e.target.value)}
                                />
                            </>
                        )
                    })()}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={closeCancelModal} disabled={cancelLoading}>Close</Button>
                    <Button
                        color="danger"
                        onClick={handleCancelSubscription}
                        disabled={cancelLoading}
                    >
                        {cancelLoading ? "Cancelling..." : "Confirm Cancel"}
                    </Button>
                </ModalFooter>
            </Modal>

            <div className="page-content">
                <Container fluid>
                    <Breadcrumb title="Manage Subscription" />
                    <Row className="subscription-page">
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <div
                                        className="btn-group btn-group-example mb-3"
                                        role="group"
                                        style={{ position: "absolute", left: "35%", zIndex: "1" }}
                                    >
                                        <button
                                            onClick={() => {
                                                setPageIndex(0)
                                                setSelectedFilter("all")
                                            }}
                                            type="button"
                                            className={`btn btn-outline-primary w-sm ${selectedFilter === "all" ? "active-subscription-status" : ""
                                                }`}
                                        >
                                            All
                                        </button>
                                        <button
                                            onClick={() => {
                                                setPageIndex(0)
                                                setSelectedFilter("paid")
                                            }}
                                            type="button"
                                            className={`btn btn-outline-primary w-sm ${selectedFilter === "paid" ? "active-subscription-status" : ""
                                                }`}
                                        >
                                            Paid
                                        </button>
                                        <button
                                            onClick={() => {
                                                setPageIndex(0)
                                                setSelectedFilter("pending")
                                            }}
                                            type="button"
                                            className={`btn btn-outline-primary w-sm ${selectedFilter === "pending" ? "active-subscription-status" : ""
                                                }`}
                                        >
                                            Unpaid
                                        </button>
                                        <button
                                            onClick={() => {
                                                setPageIndex(0)
                                                setSelectedFilter("expired")
                                            }}
                                            type="button"
                                            className={`btn btn-outline-primary w-sm ${selectedFilter === "expired" ? "active-subscription-status" : ""
                                                }`}
                                        >
                                            Expired
                                        </button>
                                        <button
                                            onClick={() => {
                                                setPageIndex(0)
                                                setSelectedFilter("cancelled")
                                            }}
                                            type="button"
                                            className={`btn btn-outline-primary w-sm ${selectedFilter === "cancelled" ? "active-subscription-status" : ""
                                                }`}
                                        >
                                            Cancelled
                                        </button>
                                    </div>
                                    <div style={{ position: "absolute", right: 0, zIndex: "1" }}>
                                        <DateRangePicker
                                          ranges={getPredefinedDateRanges()}
                                          placement="bottomEnd"
                                            onClean={() => {
                                                setPageIndex(0)
                                                setDate({
                                                    startDate: null,
                                                    endDate: null,
                                                })
                                            }}
                                            placeholder="Expiry Date"
                                            className="range-picker mb-2 date-picker-div"
                                            onChange={e => {
                                                if (e !== null) {
                                                    let [startDate, endDate] = e
                                                    startDate =
                                                        dayjs(startDate).format("YYYY-MM-DD").split("T")[0] +
                                                        "T00:00:00.000Z"
                                                    endDate =
                                                        dayjs(endDate).format("YYYY-MM-DD").split("T")[0] +
                                                        "T00:00:00.000Z"
                                                    setPageIndex(0)
                                                    setDate({
                                                        startDate: startDate,
                                                        endDate: endDate,
                                                    })
                                                }
                                            }}
                                            showOneCalendar
                                            format="dd/MM/yyyy"
                                        />
                                    </div>
                                    <DynamicTable
                                        columns={columns}
                                        data={subscriptionData}
                                        isLoading={loading}
                                        pageIndex={pageIndex}
                                        pageSize={pageSize}
                                        pageCount={Math.ceil(totalRecords / pageSize)}
                                        canPreviousPage={pageIndex > 0}
                                        canNextPage={pageIndex < Math.ceil(totalRecords / pageSize) - 1}
                                        gotoPage={setPageIndex}
                                        previousPage={() => setPageIndex(pageIndex - 1)}
                                        nextPage={() => setPageIndex(pageIndex + 1)}
                                        setPageSize={(size) => {
                                            setPageIndex(0)
                                            setPageSize(size)
                                        }}
                                        state={{ pageIndex, pageSize }}
                                        search={searchInput}
                                        handleSearchChange={(e) => {
                                            const value = e.target.value
                                            setSearchInput(value)
                                            if (value.trim() === "") {
                                                setPageIndex(0)
                                                setAppliedSearch("")
                                            }
                                        }}
                                        handleSearchClick={applySearch}
                                        totalRecords={totalRecords}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Subscription
